/* oxlint-disable no-console */

;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:qogita-web-sellers":true});}catch(e){}}();import { LogLevel, LogPayload, Transport } from '../core/types'

/*
 Improving DX because of cloudflare errors
 How to test: comment this out and go to a catalog, the lack 
 of images are exploding the dev console errors. 
 Why: Having this polluted can make some errors hard perceive the errors 
*/
function isDevelopmentEnvironmentImageError(payload: LogPayload): boolean {
  return (
    payload &&
    payload.message === 'Cloudflare Image loading failed' &&
    payload.env === 'dev'
  )
}

function log(level: LogLevel, payload: LogPayload) {
  // We have to stringify the payload because console serializes objects differently in different environments (node vs browser)
  // By serializing, we get a consistent string representation of the payload across all environments for our observability platform

  if (level === 'error' && isDevelopmentEnvironmentImageError(payload)) return

  console[level](JSON.stringify(payload))
}

export const consoleTransport: Transport = {
  error: (payload) => log('error', payload),
  warn: (payload) => log('warn', payload),
  info: (payload) => log('info', payload),
  debug: (payload) => log('debug', payload),
}
